exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container{min-height:93px}.button_wrapper,textarea{transition:all .4s ease}.button_wrapper{height:0}.focused textarea{height:80px}.focused .button_wrapper{height:45px}.footer_form{display:inline-block;background:url(/ng/assets/images/old/footer_form_logo.png) no-repeat;background-size:cover;width:38px;height:38px;margin-right:20px}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/user-opinion/user-opinion.component.css"],"names":[],"mappings":"AAAA,WACE,eAAiB,CAClB,yBAGC,uBAA2B,CAC5B,gBAGC,QAAY,CACb,kBAGC,WAAa,CACd,yBAGC,WAAa,CACd,aAGC,qBAAsB,qEAC+C,sBAC9C,WACX,YACC,iBACM,CACpB","file":"user-opinion.component.css","sourcesContent":[".container{\n  min-height: 93px;\n}\n\ntextarea, .button_wrapper{\n  transition: all 400ms ease;\n}\n\n.button_wrapper{\n  height: 0px;\n}\n\n.focused textarea{\n  height: 80px;\n}\n\n.focused .button_wrapper{\n  height: 45px;\n}\n\n.footer_form{\n  display: inline-block;\n  background: url('/assets/images/old/footer_form_logo.png') no-repeat;\n  background-size: cover;\n  width: 38px;\n  height: 38px;\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/user-opinion/user-opinion.component.css
// module id = TGPh
// module chunks = 6